import { applyTenantLanguage } from "../services/i18n";

// Sesión de demo (front-only): el "login" solo pone flags en sessionStorage.
// demoLogout las limpia, resetea el texto a clínica y devuelve al login.
export function demoLogout(navigate) {
    sessionStorage.removeItem("demoLoggedIn");
    sessionStorage.removeItem("demoOrg");
    sessionStorage.removeItem("demoOrgType");
    applyTenantLanguage("clinica");
    navigate("/login");
}
